import { useMemo, useState } from 'react';

import { urlHash } from './urlHash';

export const useHashParamState = <T>(props: {
  key: string;
  defaultValue: T;
  deserialise?: (value: string | T) => T;
  serialise?: (value: T) => string;
}) => {
  const { key, defaultValue, deserialise, serialise } = props;

  /**
   * This isn't used anywhere, it's just here to triggere a re-render
   *  so the param update can be reactive.
   */
  const [, setUrl] = useState('');
  const rawValue =
    urlHash(window.location.hash).asParams().get(key) || defaultValue;

  const param = useMemo((): T => {
    if (deserialise) {
      const parsed = deserialise(rawValue);
      if (parsed) {
        return parsed;
      }
      console.warn(
        `useHashParamState: value for key "${key}" failed schema validation, falling back to defaultValue.`
      );
      return defaultValue;
    }
    return rawValue as T;
  }, [key, defaultValue, deserialise, rawValue]);

  const setHashParam = (value: T) => {
    const uh = urlHash(window.location.hash);
    const encodedValue = serialise ? serialise(value) : value;
    uh.merge({ [key]: encodedValue });
    window.location.hash = uh.toString();
    setUrl(uh.toString());
  };

  return [param, setHashParam] as const;
};
